var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCancelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.95 7.05a1 1 0 0 0 0 1.414L10.485 12 6.95 15.536a1 1 0 1 0 1.414 1.414l3.535-3.536 3.536 3.536a1 1 0 1 0 1.414-1.414L13.314 12l3.535-3.536a1 1 0 1 0-1.414-1.414l-3.536 3.536L8.364 7.05a1 1 0 0 0-1.414 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancelWhite);
export default __webpack_public_path__ + "static/media/ic_cancel_white.8372b306630ae00e4e58413c08293e73.svg";
export { ForwardRef as ReactComponent };